module.exports = "pegasus/assets/blocks/column-18-theme2.png";